import React from 'react';
import MainLayout from './MainLayout';

const App = () => (
  <MainLayout />
);

export default App;
